import React, { useEffect, useState } from 'react'
import { useNavigation } from '@react-navigation/native'
import Wrapper from '../../Wrapper'
import Loading from '../../../Loading'
import { observer } from 'mobx-react'
import { InvoiceListItem } from '../../../../ui/atoms/InvoiceListItem'
import { getDisplayAmount } from '../../../../utils/helpers/getDisplayAmount'
import { BtText } from '@linqpal/components/src/ui'
import Toolbar from './Toolbar'
import CompanyHeader from './CompanyHeader'
import { useTranslation } from 'react-i18next'
import { styles } from './styles'

export default observer(function CompanyInactiveInvoices({ companyInvoices }) {
  const navigation: any = useNavigation()
  const [invoices, setInvoices] = useState<any[]>([])
  const [company, setCompany] = useState<any | null>(null)
  const { t } = useTranslation()

  useEffect(() => {
    setInvoices(companyInvoices)
    setCompany(companyInvoices[0]?.company)
  }, [companyInvoices])

  if (!company) return <Loading />

  return (
    <Wrapper
      containerStyle={{ alignSelf: 'center' }}
      toolbar={<Toolbar company={company} navigation={navigation} />}
    >
      <CompanyHeader
        company={company}
        totalAmount={0.0}
        style={styles.invoicesListHeader}
      />

      <BtText
        size={18}
        weight={'600'}
        style={{
          width: '100%',
          textAlign: 'center',
          marginVertical: 14,
          lineHeight: 24,
        }}
      >
        {t('TabInvoice.allPayables')}
      </BtText>

      {invoices.map((invoice) => (
        <InvoiceListItem
          key={invoice._id}
          title={`#${invoice.invoice_number}`}
          subtitle={`Due on ${new Date(invoice.invoice_due_date)
            .toDateString()
            .slice(4, 10)}`}
          status={invoice.status}
          amount={getDisplayAmount(invoice.total_amount)}
          style={{ marginBottom: 10 }}
          disabled={true}
          onPress={() => {}}
        />
      ))}
    </Wrapper>
  )
})
